import React from "react";
import { FormProvider } from "src/context/FormContext";
import { NewPremiseDetail } from "../new-premise";
import { ExposeFormContext } from "src/components/WindowRuntime";
import { ContentSection } from "./ContentSection";
import { useClaimEffects } from "./hooks/useClaimEffects";

export const Claim: React.FC = () => {
  const highOrderProps = useClaimEffects();
  return (
    <FormProvider>
      <ExposeFormContext />
      <NewPremiseDetail data-id="claimDetail" {...highOrderProps}>
        <ContentSection {...highOrderProps} />
      </NewPremiseDetail>
    </FormProvider>
  );
};
